import { z } from "zod";
import { twinExecutionCertificateV0Schema } from "./twin-execution-certificates.js";
import { twinExecutionResultEvidenceV1Schema } from "./twin-execution-certificate-evidence.js";
/** Private retained query evidence, returned only after run and source authorization. */
export const twinExecutionResultRecordSchema = z.object({
    certificate: twinExecutionCertificateV0Schema,
    certificateSha256: z.string().regex(/^[a-f0-9]{64}$/u),
    querySql: z.string().min(1).max(1_048_576),
    resultEvidence: twinExecutionResultEvidenceV1Schema,
    resultEvidenceSha256: z.string().regex(/^[a-f0-9]{64}$/u),
}).strict();
